module.exports = __webpack_public_path__ + "img/shoes-boots.292be13c.svg";